<template>
  <div class="wsa-group">

    <!-- Overlapping avatar circles -->
    <div class="wsa-strip">
      <v-tooltip
        v-for="(item, i) in avatarData"
        :key="item.id"
        :text="item.name"
        location="bottom"
      >
        <template v-slot:activator="{ props }">
          <button
            v-bind="props"
            class="wsa-avatar"
            :class="{ 'wsa-avatar--active': item.select }"
            :style="{
              '--bg': item.color_picker || fallback(i),
              '--delay': i * 0.06 + 's',
              'z-index': item.select ? 10 : avatarData.length - i
            }"
            @click="selectItem(item)"
          >
            <!-- Inner shine -->
            <span class="wsa-avatar__shine"></span>
            <!-- Initials -->
            <span class="wsa-avatar__text">{{ item.code ? item.code.slice(0,2).toUpperCase() : item.name.slice(0,2).toUpperCase() }}</span>
            <!-- Active pulse ring -->
            <span class="wsa-avatar__pulse" v-if="item.select"></span>
            <!-- Active check dot -->
            <span class="wsa-avatar__check" v-if="item.select">
              <v-icon size="7" color="#fff">mdi-check</v-icon>
            </span>
          </button>
        </template>
      </v-tooltip>

      <!-- +N more button -->
      <button
        class="wsa-avatar wsa-avatar--more"
        id="wsa-more-btn"
        v-if="listData.length > 0"
        :style="{ 'z-index': 1 }"
      >
        <span class="wsa-avatar__text">+{{ listData.length }}</span>
      </button>
    </div>

    <!-- More dropdown -->
    <v-menu activator="#wsa-more-btn" location="bottom end" :close-on-content-click="true">
      <div class="wsa-more-panel">
        <div class="wsa-more-panel__header">
          <v-icon size="11" color="#6366f1">mdi-dots-horizontal-circle-outline</v-icon>
          <span>More Workspaces</span>
        </div>
        <div class="wsa-more-panel__list">
          <button
            class="wsa-more-item"
            v-for="(item, i) in listData"
            :key="item.id"
            @click="selectItem(item)"
          >
            <span class="wsa-more-item__dot" :style="{ background: item.color_picker || fallback(i) }"></span>
            <span class="wsa-more-item__name">{{ item.name }}</span>
            <span class="wsa-more-item__code">{{ item.code }}</span>
                 <!-- Active check dot -->
            <span class="wsa-avatar__check_more" v-if="item.select">
              <v-icon size="7" color="#fff">mdi-check</v-icon>
            </span>
          </button>
        </div>
      </div>
    </v-menu>

  </div>
</template>

<script>
// import Avatar from "primevue/avatar";
// import AvatarGroup from "primevue/avatargroup";

const COLORS = ["#6366f1","#f59e0b","#10b981","#3b82f6","#f43f5e","#8b5cf6","#06b6d4","#ec4899"];

export default {
  props: ["avatarData", "moreItems"],
  // components: { Avatar, AvatarGroup },
  data() {
    return { listData: [] };
  },
  created() {
    this.listData = [...(this.moreItems || [])].sort((a, b) => a.name.localeCompare(b.name));
    this.getCurrentWS();
  },
  computed: {
    getRefreshWs() { return this.$store.getters.getMyspace; },
    getRefresh()   { return this.$store.getters.getRefreshWorkSpace; },
  },
  watch: {
    getRefreshWs() { this.getCurrentWS(); },
    getRefresh() {
      const id = localStorage.getItem("workSpaceId");
      const ws = this.avatarData.find(k => k.id == id);
      if (ws) this.selectItem(ws);
    },
  },
  methods: {
    fallback(i) { return COLORS[i % COLORS.length]; },
    getCurrentWS() {
      const id = parseInt(localStorage.getItem("workSpaceId"));
      if (this.avatarData?.length) {
        this.avatarData.forEach(k => { k.select = k.id === id; });
      }
    },
    selectItem(item) {
      this.$emit("selected", item);
      this.getCurrentWS();
    },
  },
};
</script>

<style scoped>
/* ── STRIP ── */
.wsa-group { display: flex; align-items: center; }

.wsa-strip {
  display: flex;
  align-items: center;
  /* negative margin creates the overlap */
}

/* ── AVATAR CIRCLE ── */
.wsa-avatar {
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bg, #6366f1);
  border: 2.5px solid #1e4d9b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  margin-left: -8px;
  transition: transform 0.2s cubic-bezier(0.34,1.56,0.64,1), border-color 0.18s, box-shadow 0.18s;
  animation: wsa-pop var(--delay, 0s) both;
  overflow: visible;
  flex-shrink: 0;
}
.wsa-strip .wsa-avatar:first-child { margin-left: 0; }

@keyframes wsa-pop {
  from { transform: scale(0.5); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

.wsa-avatar:hover {
  transform: translateY(-4px) scale(1.15);
  border-color: #2060c0;
  box-shadow: 0 6px 18px rgba(0,0,0,0.3);
  z-index: 20 !important;
}

/* Active state */
.wsa-avatar--active {
  border-color: #1e4d9b;
  box-shadow:
    0 0 0 3px rgba(30,77,155,0.6),
    0 6px 20px rgba(0,0,0,0.3);
  transform: translateY(-3px) scale(1.1);
}

/* Shine overlay */
.wsa-avatar__shine {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(255,255,255,0.35) 0%, transparent 55%);
  pointer-events: none;
}

/* Initials */
.wsa-avatar__text {
  font-size: 9.5px;
  font-weight: 900;
  color: #fff;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 3px rgba(0,0,0,0.35);
  position: relative;
  z-index: 1;
  line-height: 1;
}

/* Pulse ring on active */
.wsa-avatar__pulse {
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.5);
  animation: wsa-pulse 2.2s ease-out infinite;
  pointer-events: none;
}
@keyframes wsa-pulse {
  0%   { transform: scale(1);    opacity: 0.7; }
  70%  { transform: scale(1.35); opacity: 0;   }
  100% { transform: scale(1.35); opacity: 0;   }
}

/* Check dot */
.wsa-avatar__check {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #22c55e;
  border: 1.5px solid rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(34,197,94,0.6);
  z-index: 2;
}

.wsa-avatar__check_more {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #22c55e;
  border: 1.5px solid rgba(255,255,255,0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 4px rgba(34,197,94,0.6);
  z-index: 2;
}

/* More button */
.wsa-avatar--more {
  background: rgba(255,255,255,0.14) !important;
  border-color: #1e4d9b;
  backdrop-filter: blur(4px);
}
.wsa-avatar--more:hover {
  background: rgba(255,255,255,0.24) !important;
}

/* ── MORE DROPDOWN ── */
.wsa-more-panel {
  background: #ffffff;
  border-radius: 13px;
  border: 1px solid #f1f5f9;
  box-shadow: 0 12px 40px rgba(0,0,0,0.13);
  min-width: 200px;
  overflow: hidden;
}

.wsa-more-panel__header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 13px 8px;
  font-size: 10px;
  font-weight: 700;
  color: #6366f1;
  background: #f5f3ff;
  border-bottom: 1px solid #ede9fe;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.wsa-more-panel__list {
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
  max-height: 220px;
  overflow-y: auto;
}
.wsa-more-panel__list::-webkit-scrollbar { width: 3px; }
.wsa-more-panel__list::-webkit-scrollbar-thumb { background: #e0e7ff; border-radius: 3px; }

.wsa-more-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.14s;
  text-align: left;
  width: 100%;
}
.wsa-more-item:hover {
  background: #f5f3ff;
  transform: translateX(2px);
}

.wsa-more-item__dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(0,0,0,0.2);
}
.wsa-more-item__name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wsa-more-item__code {
  font-size: 9px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.4px;
  background: #f1f5f9;
  padding: 1px 5px;
  border-radius: 4px;
}
</style>
